import { render, staticRenderFns } from "./InspectionSummary.vue?vue&type=template&id=24d6005c&"
import script from "./InspectionSummary.vue?vue&type=script&lang=js&"
export * from "./InspectionSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports